import styled, { css } from 'styled-components';
import { AccountPricingPlanReference } from 'contexts/pricingPlans/identity';
import { PRICING_PLAN } from 'constants/plans_config';

export const getAccountsPricingPlanDisplayName = (name?: string | null): string => {
  if (!name) return '';

  // Only the legacy Enterprise plan ("Enterprise + Lab Experience") is abbreviated.
  // The current "Enterprise" plan keeps its name.
  return name === PRICING_PLAN.ENTERPRISE_PLUS ? 'ENT + Lab Exp' : name;
};

export const isLegacyAccountPricingPlan = (account?: AccountPricingPlanReference): boolean => {
  if (typeof account?.pricing_plan_metadata?.legacy === 'boolean') {
    return account.pricing_plan_metadata.legacy;
  }

  return account?.pricing_plan_legacy === true;
};

export const LegacyTag = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 2px 4px;
  border-radius: 4px;
  background: rgba(235, 159, 163, 0.5);
  color: var(--Business---Data-Viz-Red-Dark, #a43238);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 12px;
  text-transform: uppercase;
`;

const PlanLabel = styled.span<{ $stacked?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  max-width: 100%;
  white-space: nowrap;

  ${({ $stacked }) =>
    $stacked
      ? css`
          flex-direction: column;
          align-items: flex-start;
        `
      : css`
          flex-wrap: wrap;
        `}
`;

const PlanName = styled.span`
  white-space: nowrap;
`;

interface PricingPlanLabelProps {
  name?: string | null;
  legacy?: boolean | null;
  // Forces the LEGACY tag onto its own line instead of wrapping inline next to the plan name.
  stacked?: boolean;
}

const PricingPlanLabel = ({ name, legacy, stacked }: PricingPlanLabelProps): JSX.Element => (
  <PlanLabel $stacked={stacked}>
    <PlanName>{getAccountsPricingPlanDisplayName(name)}</PlanName>
    {legacy === true && <LegacyTag>LEGACY</LegacyTag>}
  </PlanLabel>
);

export default PricingPlanLabel;
